<cc-awesome-stage
  class="cc-app-container__awesome-stage"
  [stageConfig]="stageConfig$ | async"
  [stageBaseData]="stageBaseData$ | async"
  [stageUpdateData]="stageUpdateData$ | async"
  [mediaQuery]="mediaQuery$ | async"
  [buttonTooltipTexts]="buttonTooltipTexts$ | async"
  (fullscreenModeChange)="onFullscreenModeChange($event)"
  (interior360DataUrlChange)="onInterior360DataUrlChange($event)"
  (interiorParameterChange)="onInteriorParameterChange($event)"
  (stageViewChange)="onStageViewChange($event)"
  (stageViewStateChange)="onStageViewStateChange($event)"
  (stageHeightChange)="updateStageBackgroundHeight($event)"
  (currentVehicleImageUrl)="updateImageUrl($event)"
/>
@if (isSidebarShown$ | async) {
  <div><ng-container *ngTemplateOutlet="backgroundTemplate" /></div>
}
<!-- The background (as a template) which get dynamically injected at the correct place -->
<ng-template #backgroundTemplate>
  <div
    class="cc-main-stage__background-picture"
    [class.cc-main-stage__background-picture--blurred]="isStageViewInterior$ | async"
    [ngClass]="
      (isSidebarShown$ | async) ? 'cc-main-stage__background--with-sidebar' : 'cc-main-stage__background-template'
    "
  >
    <div
      class="cc-main-stage__background-template--wrapper"
      *ngrxLet="{ url: stageBackgroundUrl$, id: stageBackgroundId$ } as bgData"
      [ngStyle]="stickinessStyle$ | async"
      [class.cc-main-stage__background-template--wrapper-scrolled-down]="isContentScrolledDown$ | async"
    >
      <picture>
        @for (croppingData of cropping[bgData.id] | keyvalue; track croppingData) {
          @if (croppingData.key !== 'default') {
            <source
              [attr.media]="'(max-width: ' + croppingData.key + 'px)'"
              [attr.srcset]="
                bgData.url +
                '?imwidth=' +
                croppingData.value.width +
                '&im=Crop,rect=(' +
                croppingData.value.cropping.join(',') +
                '),gravity=' +
                croppingData.value.gravity
              "
            />
          }
        }
        <img
          [style.height.px]="stageBackgroundHeight$ | async"
          [style.width]="'100%'"
          [srcset]="
            bgData.url +
            '?&im=Crop,rect=(' +
            cropping[bgData.id]['default'].cropping.join(',') +
            '),gravity=' +
            cropping[bgData.id]['default'].gravity
          "
          alt=""
          width="auto"
          height="auto"
        />
      </picture>
    </div>
  </div>
</ng-template>
